export enum ProjectStep {
  PROJECT_DETAILS,
  TEAM_ROASTER,
}
